var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preload-logo"},[_c('img',{attrs:{"src":"/images/logo.png","height":"60","width":"60"}}),_c('span',{staticStyle:{"margin-top":"12px","color":"#ffa900"}},[_c('b',{staticStyle:{"color":"#275fcb","margin-left":"12px"}},[_vm._v(" Salework ")]),_vm._v(" Chat")])])
}]

export { render, staticRenderFns }